import React, { useState, useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from 'primereact/button';
import { InputText } from 'primereact/inputtext';
import { InputIcon } from 'primereact/inputicon';
import { IconField } from 'primereact/iconfield';
import { Password } from 'primereact/password';
import { PreLoginWrapper } from './PreLoginWrapper';

export const Login = () => {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(false);
    const accessToken = localStorage.getItem('accessToken');
    const refreshToken = localStorage.getItem('refreshToken');
    const navigate = useNavigate();

    useEffect(() => {
        if (accessToken && refreshToken && email) {
            navigate('/fields');
        }else{
            localStorage.removeItem('accessToken');
            localStorage.removeItem('refreshToken');
            localStorage.removeItem('email');
        }
    }, [accessToken, refreshToken, email, navigate]);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError('');

        const payload = {
            email: email,
            password: password
        };

        try {
            const response = await fetch("/waatic/login", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json"
                },
                body: JSON.stringify(payload)
            });

            const data = await response.json();
            const accessToken = data.accessToken;
            const refreshToken = data.refreshToken;
            if (accessToken === undefined || refreshToken === undefined) {
                setError(data.error);
            } else {
                localStorage.setItem('accessToken', accessToken);
                localStorage.setItem('refreshToken', refreshToken);
                localStorage.setItem('email', email);
                navigate('/fields');
            } 
        } catch (error) {
            setError("Error al iniciar sesión");
        }
    };

    return (
        <PreLoginWrapper error={error}>
            <p className="p-component mb-5 font-semibold w-full">{('Introduce tus credenciales de acceso:')}</p>
            
            <form className='w-full' onSubmit={handleSubmit}>

                <IconField className="w-full mb-3" iconPosition="left">
                    <InputIcon 
                        className="pi pi-envelope ml-2" 
                        style={{ color: 'black' }}
                        aria-label="Email icon"
                        tabIndex="-1"
                    />
                    <InputText 
                        placeholder={('Email')}
                        type="email"
                        value={email} 
                        onChange={(e) => setEmail(e.target.value)} 
                        className="w-full pl-6"
                        required
                    />
                </IconField>
                
                {/*
                <IconField className="w-full mb-5" iconPosition="left">
                    <InputIcon 
                        className="pi pi-lock ml-2" 
                        style={{ color: 'black', zIndex: 1 }}
                        aria-label="Password icon"
                        tabIndex="-1"
                    />
                    <Password 
                        placeholder={('Contraseña')}
                        value={password}
                        onChange={(e) => setPassword(e.target.value)} 
                        feedback={false} 
                        toggleMask 
                        inputClassName="w-full pl-6"
                        className="w-full"
                        pt={{ iconField: { root: { className: 'w-full' } } }} 
                        required
                    />
                </IconField>
                */}
                
                <Button 
                    label={loading ? ('Cargando...') : ('Iniciar sesión')} 
                    disabled={loading} 
                    className="bg-primary w-full" 
                />

            </form>
            
        </PreLoginWrapper>
    );
};
